import React from 'react';
import { ApprovalRequestStatus, InternalApprovalReview } from './RequestInternalApprovalModalConstants';
import styles from './InternalApprovalBadge.module.scss';

interface Props {
  approvalRequestedReviews?: InternalApprovalReview[];
  useApprovalOrder?: boolean;
  currentApproverId?: string;
  isCreator?: boolean;
  onSendReminder?: (reviewId: string) => void;
}

export const InternalApprovalApproversTooltipTable = ({
  approvalRequestedReviews,
  useApprovalOrder,
  currentApproverId,
  isCreator,
  onSendReminder,
}: Props) => {
  // Sort reviews by approval_order if sequential ordering is enabled
  const sortedReviews =
    useApprovalOrder && approvalRequestedReviews
      ? [...approvalRequestedReviews].sort((a, b) => (a.approvalOrder || 0) - (b.approvalOrder || 0))
      : approvalRequestedReviews;

  const approversList = sortedReviews?.map((review: InternalApprovalReview, index: number) => {
    const isReviewApproved = review?.approvedAt;
    const isCurrentApprover = useApprovalOrder && currentApproverId === review?.reviewer?.id;
    const isWaiting = useApprovalOrder && !isReviewApproved && !isCurrentApprover;

    let statusText: string = ApprovalRequestStatus.PENDING;
    let statusClass = 'reviewStatus';

    if (isReviewApproved) {
      statusText = ApprovalRequestStatus.APPROVED;
      statusClass = 'reviewStatus__approved';
    } else if (isCurrentApprover) {
      statusText = 'Reviewing Now';
      statusClass = 'reviewStatus__current';
    } else if (isWaiting) {
      statusText = 'Waiting';
      statusClass = 'reviewStatus__waiting';
    }

    return (
      <div key={review.id} className={styles.approversContainer}>
        <span className={styles.approverData}>
          {useApprovalOrder && <span className={styles.orderNumber}>{index + 1}. </span>}
          {isCurrentApprover && '→ '}
          {review?.reviewer?.fullName}:
        </span>
        <span className={styles[statusClass]}>{statusText}</span>
        {isCreator && isCurrentApprover && onSendReminder && (
          <button className={styles.reminderButton} onClick={() => onSendReminder(review.id)}>
            Send Reminder
          </button>
        )}
      </div>
    );
  });

  return <div style={{ minWidth: '240px' }}>{approversList}</div>;
};
